// motorCommercialService.js - API service layer for Motor Commercial Insurance
const motorCommercialService = {
	async getCommercialQuotations(vehicleType, coverType) {
		// Simulate an API call with a delay
		await new Promise((resolve) => setTimeout(resolve, 1000));

		// Mocked data based on vehicle type and cover type
		if (coverType === 'comprehensive') {
			const comprehensiveProducts = [
				{
					id: 'commercial-elite',
					name: 'Commercial Elite',
					premium: 20000,
					description:
						'Full comprehensive cover with accident and theft protection, plus special benefits for commercial use.',
					features: [
						'Accident Cover',
						'Theft Protection',
						'Third Party Liability',
						'Goods in Transit',
						'Passenger Liability',
					],
				},
				{
					id: 'commercial-plus',
					name: 'Commercial Plus',
					premium: 15000,
					description:
						'Comprehensive cover with essential commercial benefits.',
					features: [
						'Accident Cover',
						'Theft Protection',
						'Third Party Liability',
						'Goods in Transit',
					],
				},
			];
			return comprehensiveProducts;
		} else if (coverType === 'third-party-fire-theft') {
			return [
				{
					id: 'third-party-fire-theft',
					name: 'Third Party, Fire & Theft',
					premium: 10000,
					description:
						'Covers third-party liability plus loss or damage by fire and theft.',
					features: [
						'Third Party Liability',
						'Fire Damage',
						'Theft Protection',
					],
				},
			];
		} else {
			// Default to Third Party Only
			return [
				{
					id: 'third-party',
					name: 'Third Party Only',
					premium: 5000,
					description:
						'Covers liability for bodily injury or property damage to third parties.',
					features: ['Third Party Liability'],
				},
			];
		}
	},
};

export default motorCommercialService;
